export const SET_NONPROFIT_PROFILE_DATA = 'SET_NONPROFITPROFILE_PROFILE_DATA';
export const SET_ORG_KEY = 'SET_ORG_KEY';
export const SET_OPPORTUNITY = 'SET_OPPORTUNITY';
export const SET_COMPANY_ABOUT = 'SET_COMPANY_ABOUT';
export const SET_COMPANY_MISSION = 'SET_COMPANY_MISSION';
export const ADD_COMPANY_PROGRAM = 'ADD_COMPANY_PROGRAM';
export const EDIT_COMPANY_PROGRAM = 'EDIT_COMPANY_PROGRAM';
export const DELETE_COMPANY_PROGRAM = 'DELETE_COMPANY_PROGRAM';
export const ADD_COMPANY_HISTORY = 'ADD_COMPANY_HISTORY';
export const EDIT_COMPANY_HISTORY = 'EDIT_COMPANY_HISTORY';
export const DELETE_COMPANY_HISTORY = 'DELETE_COMPANY_HISTORY';
export const SET_NONPROFIT_CAUSES_DATA = 'SET_NONPROFIT_CAUSES_DATA';
export const SET_SOCIAL_MEDIA = 'SET_SOCIAL_MEDIA';
export const SET_FAVORITES = 'SET_FAVORITES';
export const SET_GENERAL_NONPROFIT_INFORMATION = 'SET_GENERAL_NONPROFIT_INFORMATION';
export const SET_COMPANY_MEDIA = 'SET_COMPANY_MEDIA';
export const DELETE_MEMBER_POSITION = 'DELETE_MEMBER_POSITION';
export const ADD_MEMBER_POSITION = 'ADD_MEMBER_POSITION';
export const DELETE_OPPORTUNITY = 'DELETE_OPPORTUNITY';
export const SET_NONPROFIT_LOCATIONS = 'SET_NONPROFIT_LOCATIONS';
export const SET_ALL_PRIORITY_LEVEL = 'SET_ALL_PRIORITY_LEVEL';
export const SET_SHORTLISTED_OPPORTUNITY = 'SET_SHORTLISTED_OPPORTUNITY';



// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/nonprofit/mutation-types.ts